import React from 'react'
import { useHistory } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { differenceInDays } from 'date-fns'
import { Container } from './styles'
import { api, authHeaders } from '../../../services/api'
import Spinner from '../../../components/Spinner'
import Planos from '../../../pages/LandingPage/Planos'

const trialDays = 30

export default function Dashboard() {
    const history = useHistory()

    const { data: pessoaModulo, isPending: isCarregandoPessoaModulo } = useQuery({
        queryKey: ['get_hired_modules_on_dashboard'],
        queryFn: async () => {
            const response = await api.get('pessoa', {
                ...authHeaders(),
                params: {
                    modulos_ativos: 1,
                    modulos_contratados: 1
                }
            })

            if(response.length > 0) {
                return response.map(item => {
                    const diasAposAssinatura = differenceInDays(new Date(), new Date(item.data_adesao))
                    const diasRestantes = trialDays - diasAposAssinatura

                    return {
                        ...item,
                        dias_restantes_trial: item.gratuidade ? null : diasRestantes
                    }
                })[0]
            } else {
                return null
            }
        },
        refetchOnWindowFocus: false
    })

    if (isCarregandoPessoaModulo) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center">
                <Spinner />
            </div>
        )
    }

    if(pessoaModulo) {
        const acessoLiberado = pessoaModulo.status === 'authorized'

        if(acessoLiberado) {
            history.push('/dashboard/prontuario')
            return null
        }
    }

    return (
        <Container className="bg-slate-200">
            <Planos />
        </Container>
    )
}
